import { render, staticRenderFns } from "./xiuxianhuodong.vue?vue&type=template&id=07a9e9b1&scoped=true&"
import script from "./xiuxianhuodong.vue?vue&type=script&lang=js&"
export * from "./xiuxianhuodong.vue?vue&type=script&lang=js&"
import style0 from "./xiuxianhuodong.vue?vue&type=style&index=0&id=07a9e9b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a9e9b1",
  null
  
)

export default component.exports